import { useIntl } from 'react-intl';

import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import type { InputProps } from '@/components/Input';
import type { InputErrorMessageProps } from '@/components/InputErrorMessage';
import { InputErrorMessage } from '@/components/InputErrorMessage';
import { InputField } from '@/components/InputField';
import { Row } from '@/components/Row';
import { SelectField } from '@/components/SelectField';
import { Typography } from '@/components/Typography';
import { usePhoneInput } from '@/hooks/usePhoneInput';
import { CONTENTSQUARE_MASKED } from '@/lib/forms/const';
import { getPhonePrefixSelectOpts } from '@/lib/phonePrefixes/helpers';
import { formMessages } from '@/messages/forms';
import * as DVM from '@/views/DeliveryView/messages';

export interface PhoneInputProps {
  error?: InputErrorMessageProps['error'];
  fullWidth?: boolean;
  inputColorVariant?: InputProps['colorVariant'];
  inputMode?: InputProps['inputMode'];
  isProcessing?: boolean;
}

export const PhoneInput = ({
  error,
  fullWidth,
  inputColorVariant = 'grey',
  inputMode,
  isProcessing,
}: PhoneInputProps) => {
  const { formatMessage } = useIntl();
  const { examplePhone } = usePhoneInput();

  return (
    <Row showRowGap>
      <Col md={4} sm={3} xs={4}>
        <SelectField
          colorVariant={inputColorVariant}
          isDisabled={isProcessing}
          name='phonePrefix'
          options={getPhonePrefixSelectOpts()}
          placeholder={formatMessage(formMessages.phoneCountryCode)}
          variant='default'
        />
      </Col>
      <Col md={fullWidth ? 8 : 5} sm={9} xs={8}>
        <Flex flexDirection='column'>
          <InputField
            autoComplete='tel'
            className={CONTENTSQUARE_MASKED}
            colorVariant={inputColorVariant}
            disabled={isProcessing}
            inputMode={inputMode}
            name='phone'
            pattern='[0-9]+'
            placeholder={formatMessage(formMessages.telephoneNumber)}
            required
            type='text'
          />
          <InputErrorMessage error={error} />
          <Typography color='secondaryGrey' scale='p3' textAlign='right'>
            {examplePhone}
          </Typography>
        </Flex>
      </Col>
      <Col md={fullWidth ? 12 : 3}>
        <Flex alignItems='center' justifyContent='flex-end'>
          <Typography color='secondaryGrey' scale='p3'>
            {DVM.MandatoryFields}
          </Typography>
        </Flex>
      </Col>
    </Row>
  );
};
